import { useEffect, useRef } from 'react'
import { ModalStore } from '../../state/ModalStore'
import { log } from '../../helpers/utils'
import { selectTemplateId } from '../Modals/SelectTemplateModal'

function OpenModalField({
    item,
    getValues,
    templates_and_attributes,
    setValue,
    ...props
}) {
    const addModal = ModalStore((state) => state.add)
    const skimModal = ModalStore((state) => state.skim)
    const modals = ModalStore((state) => state.modals)

    const button = useRef(null)

    const afterSelection = (value) => {
        log('OpenModalField', value)
    }
    const handleClick = () => {
        const Component = item.modal
        addModal(
            <Component
                {...{
                    templates_and_attributes,
                    setValue,
                    getValues,
                    afterSelection,
                    item,
                    ...props,
                }}
            />,
        )
    }

    useEffect(() => {
        let selectTemplateExists = modals.some(
            (component) => component.id === selectTemplateId,
        )
        if (button.current && !selectTemplateExists) {
            button.current.click()
        }
        return () => {
            button.current = null
            skimModal()
        }
    }, [button])

    useEffect(() => {
        return () => skimModal()
    }, [])

    return (
        <div className="py-2 hidden">
            <button type="button" ref={button} onClick={handleClick}>
                Open Modal
            </button>
        </div>
    )
}

export default OpenModalField
